/** Phase-2 ABS link — pure helpers (unit-tested under node). */

export const POOL_KEY_PREFIX = 'd2d.absLink.pool.';

export function poolKey(dealId) {
  return `${POOL_KEY_PREFIX}${dealId}`;
}

export function savePool(storage, dealId, ids) {
  if (!storage || !dealId) return;
  const clean = Array.from(new Set((ids || []).filter((x) => typeof x === 'string' && x)));
  if (clean.length) storage.setItem(poolKey(dealId), JSON.stringify(clean));
  else storage.removeItem(poolKey(dealId));
}

export function loadPool(storage, dealId) {
  if (!storage || !dealId) return [];
  try {
    const v = JSON.parse(storage.getItem(poolKey(dealId)) || '[]');
    return Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function fmtMM(n, d = 2) {
  return n == null || !Number.isFinite(Number(n)) ? '—' : `$${Number(n).toFixed(d)}MM`;
}
export function fmtX(n) {
  return n == null || !Number.isFinite(Number(n)) ? '—' : `${Number(n).toFixed(2)}x`;
}
export function fmtPct(n, d = 1) {
  return n == null || !Number.isFinite(Number(n)) ? '—' : `${(Number(n) * 100).toFixed(d)}%`;
}

/** Compress monthly rows into contiguous segments: [{state, from, to, months, breaches}] */
export function triggerSegments(rows) {
  const segs = [];
  for (const r of rows || []) {
    const state = (r.defaultTriggers || []).length ? 'default' : r.sweepActive ? 'sweep' : (r.outstanding || 0) <= 0.5 ? 'repaid' : 'normal';
    const last = segs[segs.length - 1];
    if (last && last.state === state) {
      last.to = r.date;
      last.months += 1;
      for (const b of [...(r.performanceBreaches || []), ...(r.defaultTriggers || [])]) last.breaches.add(b);
    } else {
      segs.push({ state, from: r.date, to: r.date, months: 1, breaches: new Set([...(r.performanceBreaches || []), ...(r.defaultTriggers || [])]) });
    }
  }
  return segs.map((s) => ({ ...s, breaches: [...s.breaches].sort() }));
}

/** Per-tranche balance series ($MM) for a stacked area / line chart. */
export function balanceSeries(rows, trancheIds) {
  return (trancheIds || []).map((id) => ({
    id,
    points: (rows || []).map((r, i) => [i, ((r.balances || {})[id] || 0) / 1e6]),
  }));
}

/** Pick presets by id; falls back to stress80 → 0.8. */
export function downsideFromPreset(presets, id) {
  const p = (presets || []).find((x) => x.id === id);
  return p ? { presetId: p.id, volumeMult: p.volumeMult } : { presetId: null, volumeMult: 0.8 };
}

export function linkRunBody({ dealId, pool, downside, tranches, triggers, waterfall, aroTreatedAsZero, useFreeze = true }) {
  const body = { dealId, useFreeze, aroTreatedAsZero: !!aroTreatedAsZero, downside };
  if (pool && pool.length) body.pool = pool;
  if (tranches) body.tranches = tranches;
  if (triggers) body.triggers = triggers;
  if (waterfall) body.waterfall = waterfall;
  return body;
}
